import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import styled from 'styled-components';

interface WrapperLargeProps {
  maxWidth: number;
  spacing: number;
  padding?: string;
}

export const WrapperLarge = styled(ShowOn).attrs({
  screens: [Screen.Lg, Screen.Xl, Screen.Xxl],
})<WrapperLargeProps>`
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  padding: ${({ padding = '40px' }) => padding};
  margin: 0 auto ${({ spacing }) => `${spacing}px`};
`;
